<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-section">
        <h3>Coin Identification Expert</h3>
        <p>Fast, accurate identification of coins from around the world</p>
      </div>
      
      <div class="footer-section">
        <h4>Quick Links</h4>
        <ul>
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/download">Download</router-link></li>
          <li><router-link to="/about">About Us</router-link></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h4>Support</h4>
        <ul>
          <li><a href="#">FAQ</a></li>
          <li><a href="#">User Guide</a></li>
          <li><a href="#">Contact Support</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h4>Follow Us</h4>
        <div class="social-icons">
          <a href="#" class="social-icon"><el-icon><Iphone /></el-icon></a>
          <a href="#" class="social-icon"><el-icon><Message /></el-icon></a>
          <a href="#" class="social-icon"><el-icon><ChatRound /></el-icon></a>
        </div>
      </div>
    </div>
    
    <div class="footer-bottom">
      <div class="copyright">
        © 2025 Coin Identification Expert. All rights reserved.
      </div>
      <div class="footer-links">
        <a href="#">Privacy Policy</a> | <a href="#">Terms of Use</a>
      </div>
    </div>
  </footer>
</template>

<script>
import { Iphone, Message, ChatRound } from '@element-plus/icons-vue'

export default {
  name: 'AppFooter',
  components: {
    Iphone,
    Message,
    ChatRound
  }
}
</script>

<style scoped>
.app-footer {
  background: rgba(26, 42, 108, 0.8);
  color: white;
  padding: 40px 20px 20px;
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 10;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto 30px;
}

.footer-section {
  flex: 1;
  min-width: 200px;
  margin-bottom: 20px;
  padding: 0 15px;
}

.footer-section h3 {
  font-size: 1.5em;
  margin-bottom: 15px;
  font-weight: 700;
  color: #fdbb2d;
}

.footer-section h4 {
  font-size: 1.2em;
  margin-bottom: 15px;
  color: #fdbb2d;
}

.footer-section p {
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 20px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 10px;
}

.footer-section ul li a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-section ul li a:hover {
  color: #fdbb2d;
}

.social-icons {
  display: flex;
  gap: 15px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: white;
  transition: all 0.3s ease;
}

.social-icon:hover {
  background: #fdbb2d;
  transform: translateY(-3px);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 0.9em;
  position: relative;
  z-index: 5;
}

.copyright {
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 10px;
}

.footer-links {
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 10px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.3s ease;
  padding: 0 5px;
}

.footer-links a:hover {
  color: #fdbb2d;
}

@media (max-width: 768px) {
  .app-footer {
    padding: 30px 15px 15px;
  }

  .footer-content {
    flex-direction: column;
    margin-bottom: 20px;
  }
  
  .footer-section {
    margin-bottom: 25px;
    text-align: center;
    min-width: 100%;
    padding: 0;
  }
  
  .footer-section h3 {
    font-size: 1.3em;
  }
  
  .footer-section h4 {
    font-size: 1.1em;
  }
  
  .social-icons {
    justify-content: center;
  }
  
  .footer-bottom {
    flex-direction: column;
    padding: 15px 10px;
  }
  
  .copyright, .footer-links {
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .app-footer {
    padding: 25px 10px 10px;
  }
  
  .footer-section h3 {
    font-size: 1.2em;
  }
  
  .footer-section h4 {
    font-size: 1em;
  }
  
  .footer-section p {
    font-size: 0.9em;
  }
  
  .footer-section ul li {
    margin-bottom: 8px;
  }
  
  .footer-section ul li a {
    font-size: 0.9em;
  }
  
  .social-icon {
    width: 35px;
    height: 35px;
  }
  
  .footer-bottom {
    font-size: 0.8em;
  }
}
</style> 